export default __webpack_public_path__ + "static/media/VBCoin.9583b5bb.svg";